/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import { gql } from 'urql';
import * as Urql from 'urql';

import type * as Types from '@sg/graphql-schema';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type DeliveryPreferenceType = 'CURBSIDE' | 'DOOR' | 'LEAVE_AT_DOOR';

export type ReorderDeliveryAddressQueryVariables = Exact<{
  addressId: string | number;
}>;

export type ReorderDeliveryAddressQuery = {
  readonly address: {
    readonly __typename: 'Address';
    readonly id: string;
    readonly street: string;
    readonly secondaryStreet: string | null;
    readonly city: string;
    readonly state: string;
    readonly country: string;
    readonly zipCode: string;
    readonly deliveryPreference: Types.DeliveryPreferenceType;
    readonly googlePlaceId: string;
    readonly latitude: number;
    readonly longitude: number;
    readonly name: string | null;
    readonly notes: string | null;
  } | null;
};

export const ReorderDeliveryAddressDocument = gql`
  query ReorderDeliveryAddress($addressId: ID!) {
    address(addressId: $addressId) {
      id
      __typename
      street
      secondaryStreet
      city
      state
      country
      zipCode
      deliveryPreference
      googlePlaceId
      latitude
      longitude
      name
      notes
    }
  }
`;

export function useReorderDeliveryAddressQuery(
  options: Omit<Urql.UseQueryArgs<ReorderDeliveryAddressQueryVariables>, 'query'>,
) {
  return Urql.useQuery<ReorderDeliveryAddressQuery, ReorderDeliveryAddressQueryVariables>({
    query: ReorderDeliveryAddressDocument,
    ...options,
  });
}
